var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketsReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14h11M7 19h6M7 24.015h4M13 31.015H3a2 2 0 01-2-2v-21a2 2 0 012-2h5a5 5 0 0110 0h5a2 2 0 012 2v3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.015a.5.5 0 110 1 .5.5 0 010-1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.653 30.4c.216.154.512.13.7-.06l6.987-6.987a.543.543 0 00.06-.7 2.72 2.72 0 010-3.152.543.543 0 00-.06-.701l-3.14-3.14a.543.543 0 00-.701-.06 2.72 2.72 0 01-3.152 0 .544.544 0 00-.7.06l-6.987 6.987a.544.544 0 00-.06.7 2.72 2.72 0 010 3.152.543.543 0 00.06.701l3.14 3.14a.543.543 0 00.7.059 2.72 2.72 0 013.153.001z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.678 18.706a1 1 0 011.414 0l3.202 3.202a1 1 0 010 1.414l-3.971 3.971a1 1 0 01-1.415 0l-3.201-3.201a1 1 0 010-1.415l3.97-3.97z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.385 21.077l-2.308 2.308M25.186 23.353l-.719.718",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTicketsReport;